import React from "react";
import { specStats } from "../mock";

export default function Specialisation() {
  return (
    <section className="section-dark grain">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-28">
        <p className="eyebrow eyebrow-line" style={{ color: "#a9b891" }}>Who We Work With</p>
        <h2 className="font-serif-display mt-6 text-[2.1rem] md:text-[3rem] leading-[1.05] text-[#dde3d0] max-w-3xl">
          A narrow practice, by <span className="italic-accent">design</span>.
        </h2>
        <p className="mt-6 text-[#a9b891] max-w-3xl leading-relaxed">
          We engage a small roster of private owners, overseas landlords, and boutique syndicates holding prime residential property in the world’s most tightly regulated postcodes. Our first working home is Soho, London (W1D).
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mt-14">
          {specStats.map((s) => (
            <div key={s.label} className="border-t border-[#4b5643] pt-6">
              <p className="eyebrow" style={{ color: "#a9b891" }}>{s.label}</p>
              <p className="font-serif-display text-3xl md:text-4xl text-[#dde3d0] mt-4">{s.value}</p>
              <p className="mt-2 text-sm text-[#8ea27a]">{s.sub}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
